var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F7931A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,16.2c-0.2,0-0.3,0-0.4-0.1c-0.4-0.2-0.5-0.7-0.2-1.1l6.5-9.7c0.2-0.4,0.7-0.5,1.1-0.2l3.8,2.5l3.9-5.5 c0.3-0.4,0.7-0.4,1.1-0.2c0.4,0.3,0.4,0.7,0.2,1.1l-4.4,6.1c-0.2,0.3-0.7,0.4-1.1,0.2L8.2,6.8l-6.1,9.1C2,16.1,1.7,16.2,1.5,16.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.4,8.5c-0.4-0.1-0.9,0.2-1,0.6C0.3,9.6,0.6,10,1,10.1l1.6,0.4L3.5,9L1.4,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.1,11.5l4.7,3.8c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2l4.5-3.7c0.3-0.3,0.4-0.8,0.1-1.1 c-0.3-0.3-0.8-0.4-1.1-0.1l-4,3.3L8,10.2C7.9,10.1,7.8,10,7.7,10L7.4,9.9l-0.9,1.4L7.1,11.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graph-icon.e17b1013410733087c41fdbc4b46af24.svg";
export { ForwardRef as ReactComponent };